import { render, staticRenderFns } from "./qx-table.vue?vue&type=template&id=2151a97d&scoped=true"
import script from "./qx-table.vue?vue&type=script&lang=js"
export * from "./qx-table.vue?vue&type=script&lang=js"
import style0 from "./qx-table.vue?vue&type=style&index=0&id=2151a97d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2151a97d",
  null
  
)

export default component.exports